(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  ready(function () {
    var root = document.querySelector('[data-valyrx-home]');

    if (!root) {
      return;
    }

    root.addEventListener('click', function (event) {
      var target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      var trigger = target.closest('[data-valyrx-video-trigger]');

      if (!trigger || !root.contains(trigger)) {
        return;
      }

      var videoId = trigger.getAttribute('data-video-id');
      var videoTitle = trigger.getAttribute('data-video-title') || 'The ØØØ music video';

      if (!videoId || !/^[A-Za-z0-9_-]{11}$/.test(videoId)) {
        return;
      }

      var player = document.createElement('div');
      var iframe = document.createElement('iframe');

      player.className = 'valyrx-track-card__media valyrx-track-card__media--playing';
      iframe.className = 'valyrx-track-card__player';
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(videoId) +
        '?autoplay=1&rel=0&playsinline=1';
      iframe.title = videoTitle + ' by The ØØØ';
      iframe.loading = 'eager';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.tabIndex = 0;

      player.appendChild(iframe);
      trigger.replaceWith(player);
      window.requestAnimationFrame(function () {
        iframe.focus();
      });
    });

    var beam = root.querySelector('.valyrx-hero__beam');
    var gsap = window.gsap;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!gsap || reduceMotion) {
      if (beam) {
        beam.style.transform = 'translateY(-50%) scaleX(1)';
      }
      return;
    }

    var wordmark = root.querySelector('.valyrx-hero__wordmark');
    var revealItems = root.querySelectorAll('[data-valyrx-reveal]');

    gsap.set(wordmark, { autoAlpha: 0, y: 28, filter: 'blur(9px)' });
    if (revealItems.length) {
      gsap.set(revealItems, { autoAlpha: 0, y: 16 });
    }

    var intro = gsap
      .timeline({ defaults: { ease: 'power3.out' } })
      .to(wordmark, { autoAlpha: 1, y: 0, filter: 'blur(0px)', duration: 0.8 })
      .to(beam, { scaleX: 1, duration: 0.9, ease: 'expo.out' }, '-=0.42');

    if (revealItems.length) {
      intro.to(revealItems, { autoAlpha: 1, y: 0, duration: 0.52, stagger: 0.08 }, '-=0.35');
    }

    if (!window.ScrollTrigger) {
      return;
    }

    gsap.registerPlugin(window.ScrollTrigger);

    var pageWrapper = document.querySelector('.page-wrapper');
    var scrollRoot =
      pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1
        ? pageWrapper
        : window;

    var copyGroupSelector = [
      '.valyrx-manifesto__lead',
      '.valyrx-manifesto__body',
      '.valyrx-prj__statement',
      '.valyrx-interlude',
      '.valyrx-release__caption',
      '.valyrx-video-index__heading',
      '.valyrx-section-heading',
      '.valyrx-projects__masthead',
      '.valyrx-hero-product__copy',
      '.valyrx-material__masthead',
      '.valyrx-community__masthead',
      '.valyrx-access__copy',
      '.valyrx-access__form'
    ].join(', ');

    var copyGroups = gsap.utils.toArray(copyGroupSelector);

    copyGroups.forEach(function (group) {
      var children = Array.prototype.slice.call(group.children);
      var heading = group.querySelector('h2, h3');

      if (!children.length) {
        return;
      }

      group.classList.add('valyrx-copy-motion');

      if (heading) {
        heading.classList.add('valyrx-motion-heading');
      }

      gsap.set(children, { autoAlpha: 0, y: 24 });

      var hasRevealed = false;

      function revealGroup(trigger) {
        if (hasRevealed) {
          return;
        }

        hasRevealed = true;
        group.classList.add('is-valyrx-copy-visible');
        gsap.to(children, {
          autoAlpha: 1,
          y: 0,
          duration: 0.68,
          stagger: 0.08,
          ease: 'power3.out',
          overwrite: 'auto',
          clearProps: 'transform,opacity,visibility',
        });

        if (trigger) {
          trigger.kill();
        }
      }

      window.ScrollTrigger.create({
        trigger: group,
        scroller: scrollRoot,
        start: 'top 86%',
        end: 'bottom 14%',
        onEnter: revealGroup,
        onEnterBack: revealGroup,
      });
    });

    window.ScrollTrigger.batch(
      '.valyrx-project, .valyrx-material__item, .valyrx-community__channel',
      {
        scroller: scrollRoot,
        start: 'top 90%',
        once: true,
        onEnter: function (items) {
          gsap.fromTo(
            items,
            { autoAlpha: 0, y: 18 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.52,
              stagger: 0.055,
              ease: 'power3.out',
              overwrite: 'auto',
              clearProps: 'transform,opacity,visibility',
            }
          );
        },
      }
    );

    window.ScrollTrigger.batch('[data-valyrx-card]', {
      scroller: scrollRoot,
      start: 'top 92%',
      once: true,
      onEnter: function (cards) {
        gsap.fromTo(
          cards,
          { autoAlpha: 0, y: 20 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.48,
            stagger: 0.04,
            ease: 'power3.out',
            overwrite: 'auto',
          }
        );
      },
    });

    window.ScrollTrigger.refresh();
  });
})();
